import { makeStyles } from "@material-ui/core/styles";

export const devicesPageStyles = makeStyles((theme) => ({
  alertTitle: {
    fontWeight: "bold",
  },
  leftMarginLink: {
    marginLeft: 10,
  },
  linkContainer: {
    display: "flex",
    alignItems: "center",
    paddingTop: theme.shape.padding,
  },
  secondaryLink: {
    paddingLeft: theme.shape.padding,
  },
  sectionTitle: {
    margin: 0,
    fontWeight: "bold",
  },
  quickFilterContainer: {
    display: "flex",
    alignItems: "center",
  },
  quickFilterLabel: {
    marginRight: 20,
  },
  quickFilterButton: {
    textTransform: "none",
    "&.Mui-selected:hover": {
      backgroundColor: theme.palette.action.toggleButtonHover,
    },
  },
  errorTextButton: {
    color: theme.palette.error.main,
  },
  errorContainedButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
  },
  deviceDetailOuterContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.shape.padding,
    "& p": {
      marginBottom: 0,
    },
  },
  deviceDetailInnerContainer: {
    width: "50%",
    display: "flex",
    justifyContent: "flex-start",
  },
  displayNameText: {
    marginBottom: 0,
    fontWeight: "bold",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: theme.shape.padding,
  },
  close: {
    cursor: "pointer",
  },
  dialogActions: {
    display: "flex",
    justifyContent: "space-between",
  },
  formControlLabel: {
    margin: 0,
    "& span": {
      fontSize: 14,
    },
  },
  activateButton: {
    width: 250,
    marginRight: theme.shape.padding,
  },
  unorderedList: {
    paddingLeft: theme.shape.padding,
    "& li": {
      paddingBottom: theme.shape.padding,
    },
  },
  warning: {
    marginBottom: 0,
    color: theme.palette.error.main,
  },
}));
